export function isLocalEnv() {
  // const regex = new RegExp('^kp2020-[a-zA-Z0-9]+.kaiserpermanente.org$');
  const isDev = process.env.NODE_ENV === 'development'
  return isDev
}
